// extracted by mini-css-extract-plugin
export default {"my-page-page":"styles_my-page-page__vgOc9"};